module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAQCAYAAAAiYZ4HAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAADKADAAQAAAABAAAAEAAAAAC2HIDeAAAAn0lEQVQoFZWRAQ2AIBBFnQmMYAQbaAONYgMjaAOjEMEIRNAG+HEcux2H4m1/wP3/4JxVVVDOuQGaPqMINZCBqPYshEQHWUrSqgIwZ+ikEF8TAObGA3IfARgtZGRAnh8ATR+20tTOBBjN1Hp1mOmKs5VscNO/kfylATq0MXgvGQDmwgNynwDhNf/j1FKBAKnflQUYZNhT6ytAJoAR6v35Bu8vpNucEpQ2AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/newhome/show.png
// module id = kRMq
// module chunks = 311